import { useMediaQuery } from '@mui/material'
import { VIEW_HEIGHT, VIEW_WIDTH } from 'constants/ui.contants'
import theme from 'theme'

const useResponsiveCC = () => {
    const isLargePC = useMediaQuery(theme.breakpoints.up('xl'))
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const isTablet = useMediaQuery(theme.breakpoints.down('md'))
    const isPc = useMediaQuery(theme.breakpoints.down('lg'))
    const isLaptop = useMediaQuery(theme.breakpoints.up('md'))
    
    const getHeightRatio = (height) => parseInt(height) / VIEW_HEIGHT * window.innerHeight
    const getWidthRatio = (width) => isLargePC ? parseInt(width) / VIEW_WIDTH * window.innerWidth : (parseInt(width) / VIEW_WIDTH * window.innerWidth) * 0.8

    return {
        isLargePC,
        device: isMobile ? 'mobile' : isTablet ? 'tablet' : isPc ? 'pc' : 'largePc',
        getHeightRatio,
        getWidthRatio,
        isTablet,
        isMobile,
        isLaptop,
        isPc
    }
}

export default useResponsiveCC